import React from "react";

import { useTranslation } from "react-i18next";

import TimeslotDuration from "./TimeslotDuration";
import Block from "../../block/Block";
import Input from "../../form/Input";
import Select from "../../form/Select";

import type { JSX } from "react";

interface TimeslotParametersBlockProps {
  isLoadingStuffingList: boolean;
  stuffingListOptions: { value: string; label: string }[];
  isLoadingAdbreakList: boolean;
  interstitialAdbreakOptions: { value: string; label: string }[];
}

export default function TimeslotParametersBlock({
  isLoadingStuffingList,
  stuffingListOptions,
  isLoadingAdbreakList,
  interstitialAdbreakOptions,
}: TimeslotParametersBlockProps): JSX.Element {
  const { t } = useTranslation("editor-fast-channel");

  return (
    <Block>
      <div className="relative z-10 flex flex-row gap-[3.125rem]">
        <div className="flex-1">
          <Select
            isNoWrap
            isPortal
            label={t("playMode")}
            name="fillingType"
            options={[
              { value: "single_run", label: t("single_run") },
              { value: "loop", label: t("loop") },
            ]}
          />
          <Select
            isClearable
            isNoWrap
            isPortal
            className="mb-[unset]"
            isLoading={isLoadingStuffingList}
            label={t("stuffingList")}
            name="stuffingList"
            options={stuffingListOptions}
            placeholder={t("selectStuffingList")}
          />
        </div>
        <div className="flex-1">
          <Input
            isFullWidth
            isNoWrap
            label={t("timeslotAssociatedColor")}
            name="color"
            type="color"
          />
          <Select
            isClearable
            isNoWrap
            isPortal
            className="mb-[unset]"
            isLoading={isLoadingAdbreakList}
            label={t("interstitialAdbreak")}
            name="interstitialAdbreak"
            options={interstitialAdbreakOptions}
            placeholder={t("selectInterstitialAdbreak")}
          />
        </div>
        <div className="flex-1">
          <TimeslotDuration />
        </div>
      </div>
    </Block>
  );
}
